import React from 'react';

const wrapperStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'stretch',
    height: 28,
    border: '1px solid #ccc',
    borderRadius: 6,
    overflow: 'hidden',
};

const buttonStyle: React.CSSProperties = {
    border: 'none',
    backgroundColor: '#f9f9f9',
    color: '#333',
    width: 22,
    height: '100%',
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: 14,
    lineHeight: 1,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const inputStyle: React.CSSProperties = {
    width: 56,
    height: '100%',
    textAlign: 'center' as const,
    fontSize: 13,
    border: 'none',
    borderLeft: '1px solid #ccc',
    borderRight: '1px solid #ccc',
    outline: 'none',
};

const QuantityInput = ({
    quantity,
    minQuantity,
    onChange,
}: {
    quantity: number;
    minQuantity: number;
    onChange: (newQuantity: number) => void;
}) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = Number(e.target.value);
        if (!isNaN(val)) {
            onChange(val);
        }
    };

    const increment = () => onChange(quantity + 1);

    const decrement = () => {
        onChange(quantity - 1);
    };

    return (
        <div style={wrapperStyle}>
            <button type="button" style={buttonStyle} onClick={decrement} aria-label="decrement">
                −
            </button>
            <input
                value={quantity}
                min={minQuantity}
                onChange={handleInputChange}
                style={inputStyle}
                aria-label="quantity input"
            />
            <button type="button" style={buttonStyle} onClick={increment} aria-label="increment">
                +
            </button>
        </div>
    );
};

export default QuantityInput;
